import React from 'react';

import IntakeCalendarContainer from './IntakeCalendarContainer';

import { ApplicationUser } from '../QueueBoard/models/workOrderTypes';

import { useLookupData } from '../common/hooks/useLookupData';



// Get current user from localStorage or context

const getCurrentUser = (): ApplicationUser | null => {

  try {

    const userStr = localStorage.getItem('user');

    if (userStr) {

      return JSON.parse(userStr) as ApplicationUser;

    }

  } catch {

    // Ignore parse errors

  }

  return null;

};



// Get locations from localStorage or use defaults

const getLocations = (): { locationId: number; locationName: string }[] => {

  try {

    const locationsStr = localStorage.getItem('locations');

    if (locationsStr) {

      return JSON.parse(locationsStr);

    }

  } catch {

    // Ignore parse errors

  }

  // Default locations

  return [

    { locationId: 1, locationName: 'Main Location' },

  ];

};



export const IntakeCalendarPage: React.FC = () => {

  // Load lookup data into zustand store (cached for 24 hours)

  useLookupData();



  const currentUser = getCurrentUser();

  const locations = getLocations();



  // Default to first location if none selected

  const selectedLocationId = Number(localStorage.getItem('selectedLocationId')) || locations[0]?.locationId;



  // Use a default user ID if not logged in (for development)

  const currentUserId = currentUser?.identity || 1;



  return (

    <IntakeCalendarContainer

      currentUserId={currentUserId}

      locations={locations}

      selectedLocationId={selectedLocationId}

    />

  );

};


